import EditBucketForm from './EditBucketForm'

export default EditBucketForm
